export default "__VITE_ASSET__8c4af4a7__"